<template>
    <div class="left-panel" :class="{collapsed: !expand}">
        <div class="left-panel-inner unselectable">
            <a class="btn btn-default btn-toggle" @click="expand=!expand">
                <i class="fa fa-bars" :class="{'fa-rotate-90':expand}"></i>
            </a>
            <ul v-el:nav class="nav-container">
                <li class="nav-panel"
                    v-for="(index, item) in nav"
                    :class="{'open':item.active, 'nav-open':item.active}">
                    <a :class="{'active':item.active}"
                       @click="checkItem(index,item)"
                       :href="item.href">
                        <i class="nav-icon" :class="item.icon"></i>
                        <span>{{item.title}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<style lang="stylus" scoped>
    .left-panel
        width 180px
        height 100%
        > .left-panel-inner
            height calc(100% - 54px)
            height 100%
            overflow hidden
            background-color: #1d2939
            .btn-toggle
                display block
                border none
                background-color: #394555
                border-radius: 0;
                line-height: 34px;
                height 34px
                padding 0
                color #8f939e
                &:hover
                    color #fff
                i
                    transition transform .15s ease-out
            > .nav-container
                height calc(100% - 34px)
                overflow-x hidden
                overflow-y scroll
                padding-top 3px
                margin-right: -17px;
                .nav-panel
                    position relative
                    &.open
                        > a, > a:hover
                            color #37424f
                            background-color: #fff
                    > a
                        padding 10px 12px
                        margin 2px 6px 2px 5px
                        border-radius 2px
                        display block
                        color #8f939e
                        background-color transparent
                        position relative
                        transition background-color .15s ease-in-out
                        &:hover
                            background-color: #37424f
                        &.active
                            background-color #1caf9a !important
                            color #FFF !important
                        > .nav-icon
                            font-size: 16px;
                            margin-right: 10px;
                            width: 16px;
                            text-align: center;
                    > .sub-nav
                        margin-left 33px
                        a
                            display block
                            color #8f939e
                            padding 12px 16px 12px 0
                            i
                                text-align right
                                width 10px
                            &:before
                                content: '|'
                                font-weight: bold;
                                display: inline-block;
                                width: 12px;
                                text-align: center;
                                vertical-align: text-bottom;
                            &.active
                            &:hover
                                color #1caf9a
        &.collapsed
            width 50px
            .logo-panel
                background-color: #1d2939
                border-right-color #1d2939
                img
                    display none
                h5
                    display block
            > .left-panel-inner
                overflow-x visible
                overflow-y visible
                > .nav-container
                    overflow-x visible
                    overflow-y visible
                    margin-right 0
                    > .nav-panel
                        > a
                            transition none
                            &:after
                                content: ''
                            > span
                                display none
                        &:hover
                            > a
                                background-color: #37424f
                                > span
                                    position absolute
                                    top: 0;
                                    left: 35px;
                                    min-width 160px
                                    display inline-block
                                    border-top-right-radius 2px
                                    padding 10px 12px 10px 23px
                                    background-color: #37424f
                                &.active
                                    > span
                                        background-color: #1caf9a
                            .sub-nav
                                display block !important
                                position absolute
                                min-width 150px
                                margin 0
                                left 50px
                                top 40px
                                background-color: #1d2939;
                                border-bottom-right-radius 2px
                    .sub-nav
                        display none
</style>
<script>
    export default{
        props: {
            title: {
                type: String,
                default: '我的菜单'
            },
            nav: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                expand: true,
            }
        },
        components: {},
        methods: {
            checkItem(index, item) {
                this.nav.forEach((t, i) => {
                    if (index === i) {
                        t.active = true
                    } else {
                        t.active = false
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?1aad6680